import { ContentModuleType } from '@tribeplatform/gql-client/types'
import { useEventModuleAvailability } from '@tribeplatform/react-components/Event/hooks'
import { EVENTS_BLOCK_NAME } from '@tribeplatform/react-slate-kit/constants'
import { useSlateKitContext } from '@tribeplatform/react-slate-kit/hooks'
import { BlockType } from '@tribeplatform/react-slate-kit/types'
import { In } from '@tribeplatform/react-slate-kit/utils'

import { useCustomizerNavigation } from './use-customizer-navigation.hook.js'
import { useCustomizerSpace } from './use-customizer-space.hook.js'

export const useAddBlockEditor = () => {
  const { editHeader } = useCustomizerNavigation()
  const slateKitProps = useSlateKitContext()
  const { space, editSpace } = useCustomizerSpace()
  const { isEventModuleEnabledOnNetwork } = useEventModuleAvailability()

  const allBlocks = slateKitProps.kit.getAvailableBlocks({
    context: {
      size: 'md',
      spaceType: editSpace && space ? space.type : null,
      header: editHeader,
    },
    filter: {
      type: In([BlockType.Block, BlockType.Layout]),
      usable: true,
    },
    orderBy: 'displayName',
  })

  // Filter out module blocks that are not available in the current network or space
  const blocks = allBlocks.filter(
    block =>
      block.recommendedName !== EVENTS_BLOCK_NAME ||
      (isEventModuleEnabledOnNetwork &&
        space.authMemberProps?.availableContentModules.some(
          item => item === ContentModuleType.event,
        )),
  )

  return { blocks }
}
